import React from 'react';

const Graph = (props) => {
    //console.log(props.binaryGraph);
    if (props.binaryGraph){
        const graphSrc = "data:image/png;base64," + props.binaryGraph;
        return(
            <p style={{ position:"relative", left:"1em"}}>
                <img src={graphSrc}></img>
            </p>
        )
    }else{
        return(
            <div>
            </div>
        )
    }
    
}

export default Graph;